module.exports = __webpack_public_path__ + "fonts/visuelt-pro-bold.99200509.woff";